module.exports = __webpack_public_path__ + "static/water-taxi-2.5d365e67.png";